/**
 * Titulares que usan `primary` en claro: `primary.dark` suaviza el bloque sobre fondos claros.
 * En oscuro, texto claro sobre fondos profundos.
 */
export function enProduccionConMemForegroundOnPage(theme) {
  return theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.primary.dark;
}
